import { useCallback, useEffect, useRef, useState } from "react";

import { useLockBodyScroll } from "@/lib/react-use/use-lock-body-scroll";

export const useHandleOtherMenu = () => {
	const [canShowOtherMenu, setCanShowOtherMenu] = useState(false);

	useLockBodyScroll(canShowOtherMenu);

	const tarElRef = useRef<HTMLDivElement | null>(null);

	/**
	 * @description その他以外をクリックしたらメニューを閉じる
	 */
	useEffect(() => {
		const watchEvent = (e: MouseEvent) => {
			if (tarElRef.current?.contains(e.target as Node)) return;

			setCanShowOtherMenu(false);
		};

		// add event listener
		document.addEventListener("click", watchEvent);

		// clean up
		return () => document.removeEventListener("click", watchEvent);
	}, []);

	const handleChangeCanShowOtherMenu = useCallback(() => setCanShowOtherMenu((prev) => !prev), []);

	return {
		tarElRef,
		canShowOtherMenu,

		handleChangeCanShowOtherMenu,
	};
};
